module.exports = __webpack_public_path__ + "static/media/Gymnastics - Hexagon 1.6e921959.png";